module.exports = ".switch-team-modal .modal-footer {\n  text-align: center !important; }\n\n.modal-body p {\n  text-transform: capitalize; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/custom-message/custom-message.component.scss
// module id = ./src/app/custom-message/custom-message.component.scss
// module chunks = main